// Hook para sincronizar el lote en curso desde Firestore
import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../services/firebase';

/**
 * Hook que sincroniza con Firestore para obtener el lote en curso
 * @param {number|string} remateNumero - Número del remate a sincronizar
 * @returns {Object} - { loteEnCurso, pique, isLoading, error }
 */
export const useLoteEnCurso = (remateNumero) => {
    const [loteEnCurso, setLoteEnCurso] = useState(null);
    const [pique, setPique] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Si no hay número de remate, no hacemos nada
        if (!remateNumero) {
            setIsLoading(false);
            return;
        }

        setIsLoading(true);
        setError(null);

        // Suscribirse al documento del lote en curso
        const unsubscribe = onSnapshot(
            doc(db, "lote_curso", String(remateNumero)),
            (docSnapshot) => {
                setIsLoading(false);

                if (docSnapshot.exists()) {
                    const data = docSnapshot.data();
                    if (data) {
                        setLoteEnCurso(data.lote || null);
                        setPique(data.pique || 0);
                    }
                } else {
                    // Documento no existe (remate no está en curso)
                    setLoteEnCurso(null);
                    setPique(0);
                }
            },
            (err) => {
                console.error('Error al sincronizar lote en curso:', err);
                setError(err.message);
                setIsLoading(false);
            }
        );

        // Cleanup: desuscribirse cuando el componente se desmonte
        return () => unsubscribe();
    }, [remateNumero]);

    return {
        loteEnCurso,
        pique,
        isLoading,
        error
    };
};

export default useLoteEnCurso;
